<script>
export default {
  props: {
    bdId: {
      type: String,
      required: true
    }
  },
  computed: {
    bd () {
      return this.docs.bd[this.bdId]
    },
    images () {
      return this.bd.images || [this.bd.image]
    }
  }
}
</script>

<template>
  <div class="gp-bd-article transition-item">
    <article class="level">
      <div class="media">
        <figure v-for="image in images" :key="image">
          <img :src="image">
        </figure>
      </div>
      <div class="content">
        <h1 class="has-text-weight-bold">
          <span class="is-family-oswald">{{ bd.case }}</span><br>
          <span>{{ bd.title }}</span>
        </h1>
        <h2 class="is-size-0 is-size-1-mobile has-text-weight-bold is-family-oswald">{{ bd.release }}</h2>
        <section class="item-detail">
          <h1 class="is-size-3 is-size-5-mobile has-text-weight-bold has-text-align-center-mobile">商品詳細</h1>
          <dl>
            <template v-for="(value, name) in bd.spec">
              <dt
                class="has-text-weight-bold is-size-4 is-size-6-mobile"
                :key="name"
              >
                {{ name }}
              </dt>
              <dd
                class="is-size-4 is-size-6-mobile"
                :key="value"
                v-html="value"
              ></dd>
            </template>
          </dl>
          <div class="note is-size-6 is-size-7-mobile">
            <p v-html="bd.notice"></p>
          </div>
        </section>
        <section class="shop-detail">
          <h1 class="is-size-3 is-size-5-mobile has-text-weight-bold has-text-align-center-mobile">店舗特典</h1>
          <dl>
            <template v-for="(value, name) in bd.shop">
              <dt
                class="has-text-weight-bold is-size-4 is-size-6-mobile"
                :key="name"
              >
                {{ name }}
              </dt>
              <dd
                class="is-size-4 is-size-6-mobile"
                :key="value"
                v-html="value"
              ></dd>
            </template>
          </dl>
          <div class="note is-size-6 is-size-7-mobile">
            <p>※特典内容は予告無く変更になる場合がございます。あらかじめご了承ください。</p>
            <p>※運用及び特典内容に関する詳細は各店舗にお問い合わせください。</p>
          </div>
        </section>
      </div>
    </article>
  </div>
</template>

<style lang="scss">
.shop-detail {
  dl {
    dd {
      figure {
        margin: .5rem 0;
        img {
          max-height: 16rem;
          max-width: 100%;
          width: auto;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.gp-bd-article {
  article {
    align-items: flex-start;
    @include is-mobile {
      margin: 0 1rem;
    }
    .media {
      width: 100%;
      @include is-mobile {
        padding: 0 .5rem;
      }
      @include is-not-mobile {
        max-width: 400px;
        margin-right: 2.5rem;
      }
      img {
        margin-bottom: .5rem;
      }
    }
    .content {
      width: 100%;
      @include is-not-mobile {
        max-width: 520px;
      }
      > h1 {
        @include is-mobile {
          font-size: 40px;
          line-height: 50px;
          margin-top: 1rem;
          padding: 0 .5rem;
        }
        @include is-not-mobile {
          font-size: 50px;
          line-height: 60px;
        }
      }
      > h2 {
        margin: 1.5rem 0;
        @include is-mobile {
          margin: 1rem 0 1.5rem;
          padding: 0 .5rem;
        }
        @include is-not-mobile {
          margin-left: .5rem;
        }
      }
    }
  }

  .item-detail {
    margin-bottom: 1.5rem;
    @include is-mobile {
      margin-bottom: 2.5rem;
    }
  }
  .item-detail,
  .shop-detail {
    background-color: $white-transparent;
    h1 {
      color: $yellow;
      background-color: $black;
      padding: .25rem 1rem;
      margin-bottom: 0;
    }
    dl {
      @include is-not-mobile {
        line-height: 28px;
      }
      @include is-mobile {
        line-height: 22px;
      }
      dt, dd {
        display: inline-block;
      }
      padding: .5rem;
      @include is-not-mobile {
        padding: .75rem 1rem;
      }
      dt {
        vertical-align: top;
        width: 8rem;
        &:not(:nth-last-child(2)) {
          margin-bottom: .75rem;
        }
        @include is-mobile {
          width: 5rem;
        }
      }
      dd {
        margin-left: 0;
        width: calc(100% - 8.25rem);
        word-break: break-all;
        &:not(:last-child) {
          margin-bottom: .75rem;
        }
        @include is-mobile {
          width: calc(100% - 5.25rem);
        }
      }
    }
    .note {
      padding: .25rem 1rem .5rem;
      @include is-mobile {
        padding: .25rem .5rem .5rem;
      }
      word-break: break-all;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/page/bd/bd-article.vue